import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { VaIconModule } from '@vendasta/uikit';
import { FilterModule } from '@vendasta/va-filter2';
import {
  BulkActionClickedEvent,
  Filter2TableModule,
  VaFilteredMatTableService,
  VaTableSortService,
} from '@vendasta/va-filter2-table';
import { AuxiliaryDataModule } from '../../auxiliary-data.module';
import { AuxiliaryFieldHandlerService } from '../auxiliary-field-handler.service';
import {
  AuxDataAccountsActionDependencies,
  AuxDataAccountsActionInjectionToken,
} from './auxiliary-data-accounts-table-actions.module';
import { AccountsAuxiliaryDataTableFilterService } from './auxiliary-data-accounts-table-filters.service';
import { AccountsCustomFieldsData } from './auxiliary-data-accounts-table.data-model';
import { AccountsAuxiliaryDataTableService } from './auxiliary-data-accounts-table.service';
import { AuxDataAccountsTableColumnsModule } from './column-components/auxiliary-data-accounts-table-column.module';

@Component({
  template: `
    <va-filtered-mat-table
      #filteredMatTableComponent
      [tableDataService]="accountsAuxiliaryDataTableService"
      (bulkActionClicked)="openModalForBulkAction($event)"
    ></va-filtered-mat-table>
  `,
  styles: [':host { display: block; }'],
  providers: [
    AccountsAuxiliaryDataTableService,
    VaFilteredMatTableService,
    VaTableSortService,
    AccountsAuxiliaryDataTableFilterService,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {} },
  ],
  standalone: false,
})
export class AuxiliaryDataAccountsTableInternalComponent {
  constructor(
    readonly accountsAuxiliaryDataTableService: AccountsAuxiliaryDataTableService,
    private readonly alertService: SnackbarService,
    private readonly vaFilteredMatTableService: VaFilteredMatTableService<AccountsCustomFieldsData>,
    @Inject(AuxDataAccountsActionInjectionToken) private readonly configActions: AuxDataAccountsActionDependencies,
  ) {}

  openModalForBulkAction(event: BulkActionClickedEvent): void {
    switch (event.bulkActionID) {
      case 'add-accounts-to-list':
        this.configActions.openAccountListsModal(
          event.currentSettings,
          this.vaFilteredMatTableService,
          this.accountsAuxiliaryDataTableService,
        );
        break;
      default:
        console.error(`unknown bulk action ${event.bulkActionID}`);
        this.alertService.openErrorSnack('PROSPECT_COMPONENT.BULK_ACTIONS.ERROR');
        break;
    }
  }
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    AuxiliaryDataModule,
    GalaxyEmptyStateModule,
    MatProgressSpinnerModule,
    MatIconModule,
    VaIconModule,
    Filter2TableModule,
    FilterModule,
    AuxDataAccountsTableColumnsModule,
  ],
  providers: [AuxiliaryFieldHandlerService, AccountsAuxiliaryDataTableService],
  declarations: [AuxiliaryDataAccountsTableInternalComponent],
  exports: [AuxiliaryDataAccountsTableInternalComponent],
})
export class AuxiliaryDataAccountsTableInternalModule {}
